import { Container } from "@mui/material";
import { useState } from "react";
import { AccountReportDto } from "../../../api/psc";
import { HelpIconButton, PageHeader } from "../../../components/exports";
import GenrateReport from "./GenerateReport";
import SelectReport from "./SelectReport";

// updated
export default function Report() {
    const [selectReport, setSelectedReport] = useState<AccountReportDto | null>(
        null
    );

    const handleSelectReportChange = (report: AccountReportDto) => {
        setSelectedReport(report);
    };

    const resetReport = () => {
        setSelectedReport(null);
    };

    return selectReport === null ? (
        <Container maxWidth="sm">
            <PageHeader
                title="انتخاب نوع گزارش"
                action={<HelpIconButton tag="report" />}
            />
            <SelectReport onReportChange={handleSelectReportChange} />
        </Container>
    ) : (
        <Container maxWidth="lg">
            <GenrateReport
                selectedReport={selectReport}
                resetReport={resetReport}
            />
        </Container>
    );
}
